import { PortalMapFactory } from "@domain/factories/PortalMapFactory";
import { PortalMap, PortalType } from "@studyportals/domain-client";
import { useCookie } from "nuxt/app";
//@es-lint-disable
export const usePortalMap = (): PortalMap =>{
	const portalMapCookie = useCookie<string>('PortalMap').value;
	const portalMapFactory = new PortalMapFactory();

	if(import.meta.client){
		const windowPortalMap = (window as any)['PortalMap'] as Record<PortalType, string> | undefined;
		return portalMapFactory.buildMap(windowPortalMap);
	}

	return portalMapFactory.buildMap(portalMapCookie);
}